import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Link from 'gatsby-link'

export default class Button extends Component {

    static defaultProps = {
        className: 'btn',
        href: '/',
        to: 'https://vms.locuslabs.com/',
        onClick: () => {}
    };

    static propTypes = {
        className: PropTypes.string,
        href: PropTypes.string,
        to: PropTypes.string,
        text: PropTypes.string,
        onClick: PropTypes.func
    };

    render() {
        const { href, to, className, text, onClick } = this.props;

        if(href)
            return <a href={href} className={className} onClick={onClick}>{text}</a>
        else
            return <Link to={to} className={className}  onClick={onClick}>{text}</Link>
    }
}



// WEBPACK FOOTER //
// ./src/components/Button.js